var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`iconfont icon-${_vm.iconClass}`})
}
var staticRenderFns = []

export { render, staticRenderFns }